import IWalletFinancingBase from "@/module/main/dto/financing-v3/IWalletFinancingBase";
import IPartnerWalletSettingsBase from "@/module/main/dto/financing-v3/IPartnerWalletSettingsBase";
import WalletFinancingBaseTypeEnum from "@/module/main/dto/financing-v3/WalletFinancingBaseTypeEnum";

export default class WalletFinancingBase implements IWalletFinancingBase
{
    public readonly partnerWallet?: IPartnerWalletSettingsBase;
    public readonly type: WalletFinancingBaseTypeEnum;

    constructor(props: IWalletFinancingBase)
    {
        this.partnerWallet = props.partnerWallet;
        this.type = props.type;
    }
}
